import { Button } from '@kerfjs/ui/button';
import { List } from '@kerfjs/ui/list';
import { Row } from '@kerfjs/ui/row';
import { Text } from '@kerfjs/ui/text';
import { TextField } from '@kerfjs/ui/text-field';
import type { SafeHtml } from 'kerfjs';

import { documentAnnotations, me } from '../../../../../data/state.js';
import type { GalleryPreview } from './gallery-types.js';

export function GalleryAnnotations({ active, readOnly }: { active: GalleryPreview; readOnly: boolean }): SafeHtml {
  const canModerate = me.value?.roles.some((role) => role === 'reviewer' || role === 'admin') ?? false;
  return (
    <aside class="gallery-annotations document-preview-annotations" aria-label="Image Annotations">
      <Text variant="h2" size="large" flush>
        Annotations
      </Text>
      {active.annotationLoadFailed === true ? (
        <Text tone="danger" size="compact">
          Could not load annotations. Close and reopen the image to try again.
        </Text>
      ) : null}
      {active.annotationMessage !== undefined && active.annotationMessage !== '' ? (
        <Text tone="danger" size="compact">
          {active.annotationMessage}
        </Text>
      ) : null}
      {documentAnnotations.value.length === 0 && active.point === undefined && active.annotationLoadFailed !== true ? (
        <Text tone="quiet" size="compact">
          No annotations yet.
        </Text>
      ) : null}
      {documentAnnotations.value.length > 0 ? (
        <ol>
          {documentAnnotations.value.map((annotation) => (
            <li>
              <Row gap="xs" wrap vAlign="middle">
                <Text variant="span" wrap="anywhere">
                  {annotation.body}
                </Text>
                {!readOnly && (annotation.authorMemberId === me.value?.memberId || canModerate) ? (
                  <Button
                    tone="neutral"
                    size="compact"
                    emphasis="secondary"
                    disabled={active.annotationSaving === true}
                    action="document-annotation-delete"
                    rootAttributes={{ 'data-item-id': annotation.id }}
                  >
                    Remove Note
                  </Button>
                ) : null}
              </Row>
            </li>
          ))}
        </ol>
      ) : null}
      {!readOnly && active.annotationLoadFailed !== true ? (
        <>
          <Text tone="quiet" size="compact">
            Click the image to place a note, or focus it and press Enter to use its center.
          </Text>
          {active.point ? (
            <form data-document-annotation-form>
              <List gap="xs">
                <TextField multiline name="body" label="Note" rows={3} maxLength={2000} required autofocus />
                <Row hAlign="right">
                  <Button
                    emphasis="primary"
                    type="submit"
                    tone="brand"
                    size="compact"
                    disabled={active.annotationSaving === true}
                  >
                    Save Annotation
                  </Button>
                </Row>
              </List>
            </form>
          ) : null}
        </>
      ) : null}
    </aside>
  );
}
